import { mapActions } from 'vuex';
import Events from '_utils/events';
import ProductService from '_services/rest/modules/product';
import { _RELOAD_VARIATION_ } from './ProductModel';

export default {
  name: 'product-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      ProductService.deleteProduct(this.selectedObject)
        .then(() => {
          this.close();
          this.$router.push('/admin/produtos/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Produto deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    deleteType() {
      this.setToggle({ type: 'progress', bool: true });
      const { product } = this.$store.state.product;
      if (product.id) {
        ProductService.deleteType(product.id, this.selectedObject)
          .then(() => {
            this.close();
            Events.$emit(_RELOAD_VARIATION_);
            this.$router.push(`/admin/produtos/${product.id}/1`);
            this.activeAlert({ message: 'Tipo deletada com sucesso', theme: 'success' });
          })
          .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
          .finally(() => this.setToggle({ type: 'progress', bool: false }));
      }
    },
    deleteOption() {
      this.setToggle({ type: 'progress', bool: true });
      ProductService.deleteOption(this.selectedObject)
        .then(() => {
          this.close();
          Events.$emit(_RELOAD_VARIATION_);
          this.activeAlert({ message: 'Opção deletada com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    deleteVariation() {
      this.setToggle({ type: 'progress', bool: true });
      ProductService.deleteVariation(this.selectedObject)
        .then(() => {
          this.close();
          Events.$emit(_RELOAD_VARIATION_);
          this.activeAlert({ message: 'Opção deletada com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
